import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
const DailysummaryreportEdit = () => {
  const [reportdate, setReportdate] = useState("");
  const [deposits, setDeposits] = useState("");
  const [payouts, setPayouts] = useState("");
  const [ussdcosts, setUssdcosts] = useState("");
  const [splitshare, setSplitshare] = useState("");
  const [grossgamingrevenue, setGrossgamingrevenue] = useState("");
  const [netgamingrevenue, setNetgamingrevenue] = useState("");
  const [percearning, setPercearning] = useState("");
  const [b2bpayout, setB2bpayout] = useState("");
  const [b2bpaid, setB2bpaid] = useState("");
  const [splitpaid, setSplitpaid] = useState("");
  const [redirect, setRedirect] = useState(false);
  const ref = useRef < HTMLInputElement > null;

  let { id } = useParams();
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`dailysummaryreport/${id}`);
      setReportdate(data.reportdate);
      setDeposits(data.deposits);
      setPayouts(data.payouts);
      setUssdcosts(data.ussdcosts);
      setSplitshare(data.splitshare);
      setGrossgamingrevenue(data.grossgamingrevenue);
      setNetgamingrevenue(data.netgamingrevenue);
      setPercearning(data.percearning);
      setB2bpayout(data.b2bpayout);
      setB2bpaid(data.b2bpaid);
      setSplitpaid(data.splitpaid);
    })();
  }, [id]);
  const submit = async (e) => {
    e.preventDefault();
    const { data } = await axios.put(`dailysummaryreport/${id}`, {
      reportdate,
      deposits,
      payouts,
      ussdcosts,
      splitshare,
      grossgamingrevenue,
      netgamingrevenue,
      percearning,
      b2bpayout,
      b2bpaid,
      splitpaid,
    });
    console.log(data);
    setRedirect(true);
  };

  if (redirect) {
    return <Navigate to={"/dailysummaryreport"} />;
  }
  return (
    <Wrapper pageTitle={"Edit Dailysummaryreport"}>
      <InnerNav
        createLink={"/dailysummaryreportCreate"}
        listLink={"/dailysummaryreport"}
      />
      <form onSubmit={submit}>
        <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Reportdate{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Reportdate"
              value={reportdate}
              onChange={(e) => setReportdate(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Deposits </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Deposits"
              value={deposits}
              onChange={(e) => setDeposits(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Payouts </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Payouts"
              value={payouts}
              onChange={(e) => setPayouts(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Ussdcosts </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Ussdcosts"
              value={ussdcosts}
              onChange={(e) => setUssdcosts(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Splitshare{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Splitshare"
              value={splitshare}
              onChange={(e) => setSplitshare(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Grossgamingrevenue{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Grossgamingrevenue"
              value={grossgamingrevenue}
              onChange={(e) => setGrossgamingrevenue(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Netgamingrevenue{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Netgamingrevenue"
              value={netgamingrevenue}
              onChange={(e) => setNetgamingrevenue(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Percearning{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Percearning"
              value={percearning}
              onChange={(e) => setPercearning(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">B2bpayout </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="B2bpayout"
              value={b2bpayout}
              onChange={(e) => setB2bpayout(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">B2bpaid </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="B2bpaid"
              value={b2bpaid}
              onChange={(e) => setB2bpaid(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Splitpaid </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Splitpaid"
              value={splitpaid}
              onChange={(e) => setSplitpaid(e.target.value)}
            />
          </label>

          <div className="flex mt-6 text-sm">
            <label className="flex items-center dark:text-gray-400">
              <button
                className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                onClick={submit}
              >
                {" "}
                <FiSave /> <span className="ml-3">Save</span>{" "}
              </button>
            </label>
          </div>
        </div>
      </form>
    </Wrapper>
  );
};
export default DailysummaryreportEdit;
